import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaTotalPago = (): TabelaColuna => ({
  Chave: 'TotalPago',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.moeda(linha.TotalPago)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Total Pago</div>
})
